import React, { useState, useEffect } from "react";
import GInput from "../common/input/ginput";
import { renderImg } from "../common/icons/img";
import Checkbox from "../common/input/checkbox";
import { baseCss } from "../common/css";
import { Avtar, WarningIcon } from "../common/icons/svg";
import { countdown } from "../common/helper";
import {
  AGREE_END,
  AGREE_TXT,
  AND,
  CNTRY_CODE,
  EML_ID,
  ENT_CC,
  ENT_OTP,
  FG_PWD,
  MB_NO,
  OTP_RCV_TXT,
  OTP_RSND_IN,
  OTP_SEND_NOW,
  PRIVACY,
  PWD,
  PWD_LNG_ERR,
  RE_CNFRM_PWD,
  TNC,
  UR_IP,
  VAL_EML_ID_REQ,
  VAL_PHN_NO,
  t,
} from "../../translations/Login";

const LoginForm = (props) => {
  const { data } = props;
  const { email, setEmail } = data;
  const { cccode } = data;
  const { mobile, setMobile } = data;
  const { setSlider } = data;
  const { togglePassword, setTogglePassword } = data;
  const { togglePasswordN, setTogglePasswordN } = data;
  const { togglePasswordR, setTogglePasswordR } = data;
  const { password, setPassword, passwordR, setPasswordR, blockError } = data;
  const { tncFlag, setTncFLag, resettingPassword } = data;
  const { ValidateAndReSetPassowrd } = data;
  const { loginOTP, setLoginOtp } = data;
  const { ipAddress } = props;
  const { resendLoginOTP, setResendLoginOTP } = data;
  const { loginTimer } = data;

  useEffect(() => {
    if (loginTimer == true) {
      countdown("mobileClock", 3, 0, setResendLoginOTP);
    }
  }, [loginTimer]);
  return (
    <div>
      <div className="payee-info-inputs">
        <GInput
          value={email}
          onChange={setEmail}
          errMsg={t(VAL_EML_ID_REQ)}
          label={t(EML_ID)}
          key={"emailid"}
          icon={
            <Avtar
              fillcolor="#888888"
              style={{ height: "20px", width: "20px" }}
            />
          }
          iconError={
            <Avtar fillcolor="red" style={{ height: "20px", width: "20px" }} />
          }
          validation="email"
          disabled={resettingPassword}
        />

        <GInput
          value={cccode}
          errMsg={t(ENT_CC)}
          label={t(CNTRY_CODE)}
          validation="countrycode"
          key={"cc"}
          icon={renderImg("flag-icon")}
          iconError={renderImg("flag-icon-error")}
          readonly={true}
          icon2={renderImg("filter-left-arrow")}
          onClick={() => setSlider("COUNTRY-CODE")}
          onIconClick={() => setSlider("COUNTRY-CODE")}
          disabled={resettingPassword}
        />
        <GInput
          type="tel"
          value={mobile}
          onChange={setMobile}
          validation="mobile2"
          errMsg={t(VAL_PHN_NO)}
          label={t(MB_NO)}
          key={"mobileno"}
          icon={renderImg("phone-icon")}
          iconError={renderImg("phone-icon-error")}
          disabled={resettingPassword}
        />

        {resettingPassword ? (
          <React.Fragment>
            <GInput
              type={togglePassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e)}
              errMsg={t(PWD_LNG_ERR)}
              label={t(PWD)}
              key={"password"}
              icon={renderImg("lock-icon")}
              iconError={renderImg("lock-icon-error")}
              icon2={renderImg("view-icon")}
              onIconClick={() => setTogglePassword(!togglePassword)}
              validation="password"
            />
            <GInput
              type={togglePasswordR ? "text" : "password"}
              value={passwordR}
              onChange={(e) => setPasswordR(e)}
              errMsg={t(PWD_LNG_ERR)}
              label={t(RE_CNFRM_PWD)}
              key={"passwordR"}
              icon={renderImg("lock-icon")}
              iconError={renderImg("lock-icon-error")}
              icon2={renderImg("view-icon")}
              onIconClick={() => setTogglePasswordR(!togglePasswordR)}
              validation="password"
            />
            <GInput
              type={togglePasswordN ? "text" : "password"}
              value={loginOTP}
              onChange={(e) => setLoginOtp(e)}
              errMsg={t(ENT_OTP)}
              label={t(ENT_OTP)}
              key={"password"}
              icon={renderImg("lock-icon")}
              iconError={renderImg("lock-icon-error")}
              icon2={renderImg("view-icon")}
              onIconClick={() => setTogglePasswordN(!togglePasswordN)}
              validation="password"
              max="6"
            />
            {blockError && (
              <div className="flex otp-wrong">
                {renderImg("login_error")}
                <div>{blockError}</div>
              </div>
            )}
            {!blockError && (
              <div className="flex otp-instructions">
                {renderImg("login_error")}
                <div>{t(OTP_RCV_TXT)}</div>
              </div>
            )}
            {
              <div
                style={{
                  color: "#444",
                  fontSize: "14px",
                  fontWeight: "500",
                  letterSpacing: ".02em",
                  textAlign: "center",
                  padding: "10px 0px",
                }}
              >
                {resendLoginOTP === "" ? (
                  ""
                ) : resendLoginOTP === "Resend" ? (
                  <span
                    style={{ color: "#004F9E", cursor: "pointer" }}
                    onClick={() => ValidateAndReSetPassowrd()}
                  >
                    {t(OTP_SEND_NOW)}
                  </span>
                ) : (
                  <>
                    <span>{t(OTP_RSND_IN)} </span>{" "}
                    <span
                      id="mobileClock"
                      style={{ color: "red", marginLeft: "4px" }}
                    ></span>
                  </>
                )}
              </div>
            }
          </React.Fragment>
        ) : (
          <React.Fragment>
            <GInput
              type={togglePassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e)}
              errMsg={t(PWD_LNG_ERR)}
              label={t(PWD)}
              key={"password"}
              icon={renderImg("lock-icon")}
              iconError={renderImg("lock-icon-error")}
              icon2={renderImg("view-icon")}
              onIconClick={() => setTogglePassword(!togglePassword)}
              validation="password"
            />
          </React.Fragment>
        )}

        {!resettingPassword ? (
          <div
            style={{
              textDecoration: "underline",
              marginTop: "15px",
              textAlign: "center",
              color: "var(--ksrtcThColor1)",
              cursor: "pointer",
            }}
            onClick={() => ValidateAndReSetPassowrd()}
            className="linkForgotPassword"
          >
            {t(FG_PWD)}
          </div>
        ) : (
          ""
        )}

        <div className="flex recaptcha">
          <div>{ipAddress ? `${t(UR_IP)}: ${ipAddress}` : ""}</div>
          {/* <ReCAPTCHA
                            sitekey="YOUR_RECAPTCHA_SITE_KEY" // Replace with your reCAPTCHA site key
                            onChange={handleRecaptchaChange}
                        /> */}
        </div>

        <div className="flex tnc-block">
          <Checkbox active={tncFlag} onClick={() => setTncFLag(!tncFlag)} />
          <div
            className="tnc-block-text"
          // style={{ marginLeft: "10px" }}
          >
            {t(AGREE_TXT)}  <a href="/reservation_terms" target="_blank"><span> {t(TNC)} </span></a> {/* {t(AND)}{" "}
            <span>{t(PRIVACY)}</span> {t(AGREE_END)} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
